import { createApi } from '@reduxjs/toolkit/query/react'
import axiosBaseQuery from 'api/axiosBaseQuery'

const documentApi = createApi({
  reducerPath: 'documentApi',
  baseQuery: axiosBaseQuery({
    baseUrl: process.env.REACT_APP_BASE_URL ?? ''
  }),
  tagTypes: ['Document', 'DocumentList', 'FolderTree', 'FolderList', 'Folder'],
  endpoints: () => ({})
})

export default documentApi
